import { useRouter } from "next/router";

import { useEffect, useMemo, useState } from "react";

import { findIndex } from "lodash";
import { twMerge } from "tailwind-merge";

import Swipper from "components/Swipper";
import useAuthentication from "hooks/useAuthentication";

import CollectionsPageTabs, { AVAILABLE_TABS } from "../CollectionsPageTabs";

export default function CollectionsPageLayoutMobile({ children }: any) {
  const { authenticated } = useAuthentication();
  const router = useRouter();

  const tab =
    (router.query.tab as
      | "all"
      | "unpaywalled"
      | "recommended"
      | "trending"
      | "all-countries"
      | "all-sectors"
      | "all-content-verticals"
      | "top-countries"
      | "top-sectors"
      | "top-content-verticals"
      | "followed") || "recommended";

  const [index, setIndex] = useState(0);

  const tabs: any = useMemo(() => {
    if (authenticated) {
      return AVAILABLE_TABS.filter(
        (t) => t === "separator" || !t.segments.includes("unpaywalled")
      );
    }

    return AVAILABLE_TABS.filter(
      (t) => t === "separator" || !t.segments.includes("recommended")
    );
  }, [authenticated]);

  useEffect(() => {
    const currentIndex = findIndex(tabs, (item: any) => {
      return item.segments.includes(tab);
    });

    setIndex(currentIndex);
  }, [tab, tabs]);

  return (
    <div className="mt-[54px]">
      <CollectionsPageTabs />
      <Swipper
        index={index}
        maxIndex={tabs.length}
        onIndexChange={(index) => {
          router.push(tabs[index].href);
        }}
      >
        <div
          className={twMerge("p-[15px] mb-[40px]", "min-h-[100vh]", "w-full")}
        >
          {children}
        </div>
      </Swipper>
    </div>
  );
}
